import axiosInstanceAdmin from "./axiosInstanceAdmin";

let api = axiosInstanceAdmin()

  //EmployerForm
  export const getEmployerForm = async(frmDate,toDate,  abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/EmployerForm?Created_Date_Start=${frmDate}&Created_Date_End=${toDate}`,   config)
  }